import { render, staticRenderFns } from "./storage.vue?vue&type=template&id=3fa12e59&scoped=true"
import script from "./storage.vue?vue&type=script&lang=js"
export * from "./storage.vue?vue&type=script&lang=js"
import style0 from "./storage.vue?vue&type=style&index=0&id=3fa12e59&lang=scss&scoped=true"
import style1 from "./storage.vue?vue&type=style&index=1&id=3fa12e59&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa12e59",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fa12e59')) {
      api.createRecord('3fa12e59', component.options)
    } else {
      api.reload('3fa12e59', component.options)
    }
    module.hot.accept("./storage.vue?vue&type=template&id=3fa12e59&scoped=true", function () {
      api.rerender('3fa12e59', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/setting/enterprise/setup/components/storage.vue"
export default component.exports